import { relationships } from "@rocicorp/zero";
import { crew } from "./crew";
import { organization } from "./organization";
import { plan } from "./plan";
import { vehicleAssignmentsPlan } from "./vehicle-assignment-plan";

export const planRelationships = relationships(plan, ({ many, one }) => ({
	crews: many({
		sourceField: ["id"],
		destField: ["planId"],
		destSchema: crew,
	}),
	organization: one({
		sourceField: ["orgId"],
		destField: ["id"],
		destSchema: organization,
	}),
	vehicleAssignmentsPlan: many({
		sourceField: ["id"],
		destField: ["planId"],
		destSchema: vehicleAssignmentsPlan,
	}),
}));
